import { List, ListItem } from '@mui/material'
import { FunctionComponent, ReactNode } from 'react'

interface Props {
  items: ReactNode[]
}

const BulletedList: FunctionComponent<Props> = ({ items }) => {
  return (
    <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
      {items.map((item, idx) => (
        <ListItem key={idx} sx={{ display: 'list-item' }}>
          {item}
        </ListItem>
      ))}
    </List>
  )
}

export default BulletedList
